import { CART_RECEIVE, CART_SHOW_INFO, CART_DISMISS_NOTIFICATION } from '../Actions/Cart.action';

export const cart = (state = { quantity: 0, orderTotal: 0, showInfo: false, notifications: [] }, action) => {
    switch (action.type) {
        case CART_RECEIVE:
            return {
                ...state,
                ...action.payload,
                notifications: action.payload.notifications || [],
            };
        case CART_SHOW_INFO:
            return {
                ...state,
                ...action.payload,
            };
        case CART_DISMISS_NOTIFICATION:
            return {
                ...state,
                notifications: (state.notifications || []).filter((_, i) => i !== action.payload.index),
            };
        default:
            return state;
    }
}
